import { render, staticRenderFns } from "./pay_level.vue?vue&type=template&id=3bdfcb0c&scoped=true&"
import script from "./pay_level.vue?vue&type=script&lang=js&"
export * from "./pay_level.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdfcb0c",
  null
  
)

export default component.exports